
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import PartsLayout from '../common/parts/PartsLayout.vue'
import { LayoutConfig, Part, Parts } from '../common/parts/types'
import * as typesAccount from '@account/store/types'

@Component({
    components: { PartsLayout },
    computed: {
    ...mapGetters({
      current: typesAccount.CURRENT,
    }),
  },
})
export default class WebpartPage extends Vue {
    @Prop({ type: Number, required: true }) pageid!: number

    layout: LayoutConfig = Object.create(null)
    parts: Parts = []
    current!: account.TCurrent

    async created() {
        const { pageid } = this
        // 자신을 맴버로 가지고 있는 권한 그룹이 할당된 웹파트 목록과
        // 자신에게 할당된 웹파트 템플릿 조회
        const template = await this.portalCache.webpartsv3.getMyTemplate()
        // 웹파트 페이지에 해당하는 템플릿을 가져온다.
        const {
            id: templateId,
            cols,
            rows,
            rowHeight,
            designWidth,
            parts,
        } = template
        // 템플릿 레이아웃 설정
        this.layout = {
            cols,
            rows,
            rowHeight,
            designWidth,
            personal: true,
        }
        const { webparts: ids } = this.current.permissions

        // 웹파트 레이아웃에서 사용 가능한 모든 웹파트
        if (parts) {
            this.parts = [
                // 웹파트 템플릿의 디자이너 레이아웃에 배치되어 있는 웹파트들
                ...parts.map<Part>((x:any) => {
                    var opt = this.portalCache.webpartsv3.webparts?.filter(i=>i.id==x.id)[0].props || x.props
                    if(opt && typeof(opt)==typeof('')) opt=JSON.parse(opt)
                    return {
                        ...x,
                        webpartId:x.id,
                        available: false,
                        props: {
                            ...opt,
                            preview: false 
                        },
                    }
                }),
            ]
            this.parts = this.parts.filter((x)=>ids.includes(x.webpartId))
        }
    }
}
